module.exports = __webpack_public_path__ + "img/6.b3b7692a.jpg";